import React from 'react';
import {
    ColumnPickerModal,
    PickableItem,
} from '@instinet-analytics/semantic-ui-components';

import { useDispatchUpdateVisibleColumns } from 'widgets/store/grid/visibleColumns/dispatcher';

import {
    HistoricalPercentageChangeWidgetGridColumn,
    historicalPercentageChangeWidgetColumnsDefinitions,
} from './columns';
import {
    initialHistoricalPercentageChangeWidgetConfigState,
    useHistoricalPercentageChangeWidgetConfigSlice,
} from 'widgets/historicalPercentageChange/widget/store.ts';

export default function HistoricalPercentageChangeWidgetGridColumnPicker() {
    const {
        config: { visibleColumns },
    } = useHistoricalPercentageChangeWidgetConfigSlice();

    const allPickableItems: PickableItem<HistoricalPercentageChangeWidgetGridColumn>[] =
        historicalPercentageChangeWidgetColumnsDefinitions.map((column) => ({
            value: column.field as HistoricalPercentageChangeWidgetGridColumn,
            name: column.name || column.field!,
            desc: column.headerTooltip ?? column.name,
        }));

    const dispatchUpdateVisibleColumns = useDispatchUpdateVisibleColumns();

    const onUpdateVisibleColumns = (
        cols: HistoricalPercentageChangeWidgetGridColumn[]
    ) => {
        dispatchUpdateVisibleColumns(cols);
    };

    return (
        <ColumnPickerModal
            selectedValues={visibleColumns}
            defaultSelectedValues={
                initialHistoricalPercentageChangeWidgetConfigState.visibleColumns
            }
            allItems={allPickableItems}
            hideGroupView={true}
            hideSearch={true}
            onUpdateSelectedValues={onUpdateVisibleColumns}
        />
    );
}
